let d = window.define;